export default "__VITE_ASSET__DwH6nC8u__"